import { fade, makeStyles } from '@material-ui/core/styles'
import { bg2, bg3 } from 'containers/MaterialUiContainer/mainTheme'

export const useStyles = makeStyles((theme) => ({
  iconButton: {
    boxShadow: '0px 1px 3px #DBDFE7',
    backgroundColor: theme.palette.common.white,
  },
  blueRoundedBlock: {
    backgroundColor: bg3,
    borderRadius: '0.5rem',
  },
  collectedBlock: {
    backgroundColor: bg3,
    borderRadius: '0.5rem',
    '& .percentage-badge': {
      fontSize: '1.1rem',
      color: theme.palette.text.secondary,
      fontWeight: 600,
      marginLeft: '0.75rem',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      padding: '0.25rem 0.5rem',
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '0.375rem',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
  },
  clientName: {
    fontSize: '2.5rem',
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  sectionLabel: {
    fontSize: '1.5rem',
  },
  groupBoxStyle: {
    border: '1px solid #E0E3E6',
    borderRadius: 6,
    padding: '0.5rem 1rem',
    marginBottom: 8,
    background: '#fff',
  },
  compactCell: {
    padding: '2px 2px',
    fontSize: 14,
  },
  compactRow: {
    height: 16,
  },
  documentDateCell: {
    width: '1%',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    paddingLeft: 16,
  },
  contactIcon: {
    marginRight: '1rem',
  },
  contactText: {
    fontSize: '1.1875rem',
  },
  popover: {
    overflow: 'inherit',
    '&:after': {
      width: 0,
      height: 0,
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      borderBottom: `0.8rem solid ${theme.palette.common.white}`,
      top: '-0.8rem',
      right: '1.2rem',
      display: 'table',
      content: '""',
      position: 'absolute',
    },
  },
  menuItem: {
    height: '3.25rem',
  },
  iconContainer: {
    border: `1px solid ${fade(theme.palette.secondary.main, 0.2)}`,
    background: bg2,
    padding: '0.4rem',
    marginRight: '0.75rem',
    borderRadius: '0.375rem',
    height: '2rem',
    width: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  roundBorder: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '6px',
  },
  tooltip: {
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: theme.shadows[4],
    maxWidth: 320,
    padding: theme.spacing(2),
    borderRadius: 12,
  },
  tooltipContent: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  optionBox: {
    marginBottom: theme.spacing(2.5),
  },
  clickableText: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  mainTitle: {
    fontWeight: 600,
    fontSize: '1.025rem',
    marginBottom: theme.spacing(1),
  },
  optionTitle: {
    fontWeight: 500,
  },
  currentOptionTitle: {
    fontWeight: 600,
  },
  detailText: {
    color: '#667085',
    fontSize: '0.75rem',
    lineHeight: 1.4,
  },
  inactiveOption: {
    opacity: 0.5,
    color: theme.palette.grey[500],
  },
  discountButton: {
    padding: 4,
    border: '1px solid #d0d5dd',
    borderRadius: '50%',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
    marginLeft: 8,
  },
}))

export const usePopoverStyles = makeStyles((theme) => ({
  popover: {
    overflow: 'inherit',
    '&:after': {
      width: 0,
      height: 0,
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      borderBottom: `0.8rem solid ${theme.palette.common.white}`,
      top: '-0.8rem',
      right: '1.5rem',
      display: 'table',
      content: '""',
      position: 'absolute',
    },
  },
  menuItem: {
    position: 'relative',
    height: '3.5rem',
  },
  iconContainer: {
    border: `1px solid ${fade(theme.palette.secondary.main, 0.2)}`,
    background: bg2,
    padding: '0.4rem',
    marginRight: '0.75rem',
    borderRadius: '0.375rem',
    height: '2rem',
    width: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dividerRoot: {
    margin: '1rem auto',
    width: 'calc(100% - 4rem)',
  },
}))
